function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { isFieldEmpty } from "@limitless/common/utils";
import CheckTextField from "./CheckTextField";
const LongTextField = ({
  check,
  onChange,
  ...rest
}) => {
  const {
    isInvalid = false
  } = check;
  const validateLongTextAndUpdate = newValue => {
    let isInvalid = false;
    if (isFieldEmpty(newValue) || newValue.length > 500) {
      isInvalid = true;
    }
    onChange(newValue, isInvalid);
  };
  return /*#__PURE__*/React.createElement(CheckTextField, _extends({}, rest, {
    check: check,
    onChange: validateLongTextAndUpdate,
    helperText: isInvalid ? "Must be 500 characters or less" : null,
    placeholder: "Type your answer here...",
    multiline: true,
    rows: 5
  }));
};
export default LongTextField;
LongTextField.propTypes = {
  check: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};